import { RouteConfig } from 'vue-router'

const Recharge = () => import('../../views/jump-jump-coin/Recharge.vue')
const RechargeVip = () => import('../../views/jump-jump-coin/RechargeVip.vue')

export const rechargeRoute: RouteConfig = {
  path: '/jump-jump-coin/recharge',
  name: 'jump_jump_coin_recharge',
  component: Recharge,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '天天跳绳支付中心',
    needLogin: true,
  },
}

export const rechargeVipRoute: RouteConfig = {
  path: '/jump-jump-coin/recharge-vip',
  name: 'jump_jump_coin_recharge_vip',
  component: RechargeVip,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '天天跳绳支付中心',
    needLogin: true,
  },
}

export default [rechargeRoute, rechargeVipRoute]
